// extracted by mini-css-extract-plugin
export default {"layout":"toast_layout__Ajguk","modal":"toast_modal__6T8gl","message":"toast_message__8Q4P+","footer":"toast_footer__mK71P","button":"toast_button__LPLVE"};